module.exports = "<app-navbar *ngIf=\"removeNavbar()\"></app-navbar>\r\n<router-outlet></router-outlet>\r\n<app-footer *ngIf=\"removeFooter()\"></app-footer>"